/** Stripe Connect test ids — mirrored in @test-kit STRIPE_CONNECT (keep in sync). */
export type StripeConnectMode = 'test' | 'live';
export const STRIPE_CONNECT_TEST_IDS = {
  card: (mode: StripeConnectMode) => `stripe-connect-card-${mode}`,
  connectBtn: (mode: StripeConnectMode) => `stripe-connect-btn-${mode}`,
  statusChip: (mode: StripeConnectMode) => `stripe-connect-status-${mode}`,
  refreshBtn: (mode: StripeConnectMode) => `stripe-connect-refresh-${mode}`,
  disconnectBtn: (mode: StripeConnectMode) => `stripe-connect-disconnect-${mode}`,
  disconnectConfirmBtn: 'stripe-connect-disconnect-confirm',
} as const;
